/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA2Ljc5TDEyLjcxIDcuNUw4IDEyLjIxTDMuMjkgNy41TDQgNi43OUw3LjUgMTAuMjlWMEg4LjVWMTAuMjlMMTIgNi43OVpNMTUgMTVWMTBIMTZWMTZIMFYxMEgxVjE1SDE1WiIgZmlsbD0iaW5oZXJpdCIvPg==";